import { HOME_PROJECT_ID } from '@/lib/appConstants.js';
import getModelOptions from '@/lib/model/getModelOptions.js';
import { DEFAULT_PIEVE_MODEL_ID } from '@shared/pieve/defaultModel.js';

export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const THREAD_SANDBOX_MODE_DEFAULT = 'workspace-write';
export const COMPOSER_MODEL_OPTIONS = getModelOptions();
export const DEFAULT_COMPOSER_MODEL_ID = DEFAULT_PIEVE_MODEL_ID;

export { HOME_PROJECT_ID };
